<template>
  <div class="container page Shuadan">
    <van-nav-bar title="" class="nav-bar">
      <template #right>
        <img src="../../assets/order-fill.png" alt="" style="width: 35px; height: 35px; margin-right: 10px;"
          @click="toOrder">
        <van-image src="img/mine/kf.png" width="35" height="35" @click="toService()">
          <template v-slot:loading>
            <van-loading type="spinner" />
          </template>
        </van-image>
      </template>
    </van-nav-bar>
    <div class="shuadanTop">
      <div class="Introduction">
        <div>
          <van-swipe :autoplay="3000" indicator-color="white" height="200">
            <van-swipe-item v-for="(v, key) in banners" :key="key">
              <van-image :src="v.goods_pic" :height="200" width="100%" fit="cover">
                <template v-slot:loading>
                  <van-loading type="spinner" size="20" />
                </template>
                <template v-slot:error><van-image src="img/error.png" /></template>
              </van-image>
            </van-swipe-item>
          </van-swipe>
        </div>
        <div
          style="position: absolute; bottom: 0; width: 100%; background: rgba(0,0,0,0.2); font-size: 11px; padding: 10px; border-radius: 10px 10px 0 0;">
          {{ notice }}
        </div>
      </div>
      <div class="qdbox">
        <div class="Income" v-if="userInfo.level && Number(userInfo.level) > 0">
          <div>
            <div @click="showType = 1">{{ $t('Membershipincome') }}</div>
            <div @click="showType = 2">{{ $t('Rules') }}<van-icon name="info-o" size="18" /></div>
          </div>
          <div class="IncomeMain" v-show="showType == 1">
            <div>
              <p>{{ $t('Balance') }}</p>
              <p>{{ income.balance || 0 }}</p>
            </div>
            <div>
              <p>{{ $t('Income') }}</p>
              <p>{{ income.today_complete_price || 0 }}</p>
            </div>
            <div>
              <p>{{ $t('Totaldeposit') }}</p>
              <p>{{ income.current_count_complete || 0 }} / {{ income.current_count_sy || 0 }}</p>
            </div>
            <div>
              <p>{{ $t('Totalwithdrawal') }}</p>
              <p>{{ income.order_price || 0 }}</p>
            </div>
          </div>
          <div class="IncomeRules" v-show="showType == 2">{{ rules }}</div>
          <div class="GrabOrder" @click="submitOrder">{{ $t('GrabOrder') }}</div>
        </div>
        <div class="v0box" v-else>
          <div>❤️{{ $t('v0tips1') }}❤️</div>
          <div>{{ $t('v0tips2') }}</div>
        </div>
      </div>
    </div>
    <div class="shuadanBtm">
      <div>{{ $t('v0tips3') }}</div>
      <div class="Rechargelist">
        <div v-for="(v, i) in goodslist" :key="i" class="item">
          <div>
            <img v-if="i % 2 == 0 && v[0]" class="firstimg" :src="v[0] ? v[0].goods_pic : ''" alt=""
              @click="toDetail(v[0] || {})">
            <div>
              <img v-if="v[1]" :src="v[1] ? v[1].goods_pic : ''" alt="" @click="toDetail(v[1] || {})">
              <img v-if="v[2]" :src="v[2] ? v[2].goods_pic : ''" alt="" @click="toDetail(v[2] || {})">
            </div>
            <img v-if="i % 2 != 0 && v[0]" class="firstimg" :src="v[0] ? v[0].goods_pic : ''" alt=""
              @click="toDetail(v[0] || {})">
          </div>
        </div>
      </div>
    </div>
    <van-popup v-model="showQD" :style="{ width: '90%', height: '62%' }">
      <img :src="hotelInfo.goods_pic" alt="" class="QDimg">
      <div class="GrabOrder2" @click="SubmitForm">{{ $t('Submit') }}</div>
      <div class="QDbox">
        <div>{{ $t('Restaurantname') }}: {{ hotelInfo.goods_name }}</div>
        <div>{{ $t('Totalamount') }}: {{ hotelInfo.num }} {{ $t('MAD') }}</div>
        <!-- {{ $t('OrderQuantity') }}:  -->
        <div>{{ $t('OrderQuantityTxt') }}</div>
        <div>{{ $t('Expectedreturn') }}:
          <span style="color: #1abe75; font-weight: bold;">+ {{ hotelInfo.commission }} {{ $t('MAD') }}</span>
        </div>
        <div>{{ $t('Ordernumber') }}: {{ hotelInfo.id }}</div>
        <div>{{ $t('Submissiontime') }}:
          {{ new Date(hotelInfo.addtime * 1000).toLocaleDateString().replace(/\//g, "-") + " " + new
            Date(hotelInfo.addtime
              * 1000).toTimeString().substr(0, 8) }}
        </div>
      </div>
    </van-popup>
    <van-dialog width="80%" v-model="showKF" confirmButtonColor="#8d47ef" :confirmButtonText="$t('confirmButtonText')"
      :message="kfmessage" @confirm="toService"></van-dialog>
  </div>
</template>

<script>
import config from "../../http/config";
export default {
  data() {
    return {
      config,
      showQD: false,
      banners: [],
      notice: "",
      rules: "",
      income: {},
      hotelInfo: {},
      goodslist: [],
      showType: 1,
      showKF: false,
      kfmessage: "",
      userInfo: {},
    };
  },
  created() {
    if (localStorage.getItem('token')) {
      this.getUserInfo();
      this.init();
    } else {
      this.$router.push({ path: '/Login' });
    }
  },
  methods: {
    getUserInfo() {
      this.$httpNew({
        method: 'post',
        url: 'get_user_info',
        data: {},
      }).then(res => {
        if (res.code == 0) {
          this.userInfo = res.user_info || {};
        }
      })
    },
    init() {
      // 首页滚动内容
      this.$httpNew({
        method: 'get',
        data: {
          id: this.NotifyIds[this.$i18n.locale],
        },
        url: 'get_notice'
      }).then(res => {
        if (res.code == 0) {
          this.rules = res.content.replace(/<[^>]*>/g, '');
        } else {
          this.rules = "";
        }
      })
      // 酒店刷单规则
      this.$httpNew({
        method: 'get',
        data: {
          id: this.BrushingRulesIds[this.$i18n.locale],
        },
        url: 'get_notice'
      }).then(res => {
        if (res.code == 0) {
          this.notice = res.content.replace(/<[^>]*>/g, '');
        } else {
          this.notice = "";
        }
      })
      // 会员收入
      this.$httpNew({
        method: 'post',
        data: {},
        url: 'get_income'
      }).then(res => {
        if (res.code == 0) {
          this.income = res.data || {};
          this.income.current_count_complete = this.income.current_count - this.income.current_count_sy;
        } else {
          this.income = {};
        }
      })
      // 酒店列表
      this.$httpNew({
        method: 'get',
        data: {
          type: this.HotelData[this.$i18n.locale],
        },
        url: 'get_hotel_list'
      }).then(res => {
        if (res.code == 0) {
          this.goodslist = this.reorganizationArr(res.data || []);
          this.banners = this.goodslist[0];
        } else {
          this.goodslist = [];
          this.banners = [];
        }
      })
    },
    toService() {
      this.$router.push({ path: '/customerservice' });
    },
    submitOrder() {
      // 抢单酒店信息
      this.$toast.loading({
        message: this.$t('loadingtext'),
        forbidClick: true,
      });
      this.$httpNew({
        method: 'post',
        data: {
          cid: this.QDData[this.$i18n.locale], // 商品分类id
          // reCAPTCHA: "",
          // v: this.$store.getters.getUserInfo.level, // 用户等级
          // m: Math.random(),
          // real: this.$store.getters.getUserInfo.is_jia, // 是否假人
        },
        url: 'submit_order'
      }).then(res => {
        if (res.code == 0) {
          this.$httpNew({
            method: 'get',
            data: {
              oid: res.oid,
            },
            url: 'get_order_info'
          }).then(order_info => {
            this.$toast.clear();
            if (order_info.code == 0) {
              this.hotelInfo = order_info.data || {};
              this.showQD = true;
            } else {
              this.$toast(order_info.info);
            }
          })
        } else {
          this.$toast(res.info);
        }
      })
    },
    SubmitForm() {
      this.$toast.loading({
        message: this.$t('loadingtext'),
        forbidClick: true,
      });
      this.$httpNew({
        method: 'post',
        data: {
          oid: this.hotelInfo.id,
          status: 1,
        },
        url: 'do_order'
      }).then(res => {
        this.$toast.clear();
        if (res.code == 0) {
          this.$toast(res.info);
          this.showQD = false;
          this.init();
        } else if (res.code == 2) {
          // 余额不足，弹窗提示前往客服
          this.kfmessage = res.info;
          this.showKF = true;
        } else {
          this.$toast(res.info);
        }
      })
    },
    toDetail(v) {
      this.$router.push({ path: '/fakeTransactionsDetail', query: { id: v.id } });
    },
    toOrder() {
      this.$router.push({ path: '/fakeTransactionsList' })
    },
    reorganizationArr(data) {
      var result = [];
      for (var i = 0; i < data.length; i += 3) {
        result.push(data.slice(i, i + 3));
      }
      return result;
    },
  },
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";

.Shuadan {
  // background: url('../../assets/shuadan_bg.jpg') no-repeat top center;
  // background-size: cover;
  overflow: auto;
  padding-bottom: 120px;
}

.nav-bar {
  .right {
    padding: 0 8px;
  }
}

.shuadanTop {
  padding: 5px 5px 0;

  .Introduction {
    margin-bottom: 5px;
    color: #fff;
    position: relative;
  }

  .qdbox {
    padding: 15px;
    background: linear-gradient(90deg, #323233, #000000);
    color: #fff;
    border-radius: 10px;

    .v0box {
      text-align: center;

      >div {
        padding: 5px 0;
      }
    }
  }

  .Income {
    >div:nth-child(1) {
      border-bottom: 1px solid #fff;
      padding-bottom: 15px;
      display: flex;
      justify-content: space-between;

      >div:nth-child(2) {
        display: flex;
        align-items: center;

        .van-icon {
          margin: 2px 0 0 5px;
        }
      }
    }

    .IncomeMain {
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;
      text-align: center;

      >div {
        flex: 0 0 50%;

        p {
          margin: 10px 0 0;
        }

        >p:nth-child(1) {
          font-weight: 700;
        }
      }
    }

    .IncomeRules {
      padding: 15px 15px 0;
    }
  }
}

.shuadanBtm {
  padding: 15px;

  >div:nth-child(1) {
    color: #000;
    text-align: center;
    font-weight: bold;
  }

  .Rechargelist {
    .item {
      >div {
        display: flex;
        // align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;

        >div {
          width: 49%;
        }

        img {
          width: 100%;
          height: 200px;
          object-fit: cover;
          margin-top: 10px;
          display: block;
          border-radius: 8px;
        }

        .firstimg {
          width: 49%;
          height: 420px;
        }
      }
    }
  }
}

.QDimg {
  width: 100%;
  height: 500px;
  margin-right: 10px;
  display: block;
  object-fit: cover;
  margin: 0;
}

.QDbox {
  padding: 15px;

  >div {
    padding: 5px 0;
    font-size: 14px;
    box-sizing: border-box;
  }
}

.GrabOrder {
  background: #fff;
  color: #000;
  border-radius: 8px;
  padding: 10px 0;
  text-align: center;
  font-size: 32px;
  margin-top: 20px;
  line-height: 50px;
}

.GrabOrder2 {
  background: linear-gradient(90deg, #323233, #000000);
  color: #fff;
  border-radius: 8px;
  padding: 10px 0;
  text-align: center;
  font-size: 32px;
  margin-top: 20px;
  line-height: 50px;
}

::v-deep .van-dialog__footer {
  padding: 10px 0;
}

::v-deep .van-dialog__message {
  padding: 20px;
}
</style>
